// Admin portal shows every date in Calgary time, matching emails and scheduled jobs
export const BUSINESS_TZ = "America/Edmonton";

export const mtDateTime = (v) => (v ? `${new Date(v).toLocaleString("en-CA", { timeZone: BUSINESS_TZ, year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "2-digit" })} MT` : "—");
export const mtDate = (v, opts = { year: "numeric", month: "short", day: "numeric" }) => (v ? new Date(v).toLocaleDateString("en-CA", { timeZone: BUSINESS_TZ, ...opts }) : "—");
